import { DatatableComponent } from '@swimlane/ngx-datatable';
import { TemplateFilters } from '@models';

export class UpdateAssetTemplatesPageSize {
    static readonly type = '[Asset Templates] Update Asset Templates Page Size';
    constructor(public pageSize: number) { }
}

export class UpdateAssetTemplatesSearchQuery {
    static readonly type = '[Asset Templates] Update Asset Templates Search Query';
    constructor(public searchQuery: string) { }
}

export class UpdateAssetTemplatesActivePage {
    static readonly type = '[Asset Templates] Update Asset Templates Active Page';
    constructor(public activePage: number) { }
}

export class UpdateAssetTemplatesSort {
    static readonly type = '[Asset Templates] Update Asset Templates Sort';
    constructor(public sort: { name: string, prop: string, direction: 'asc' | 'desc' }) { }
}

export class UpdateAssetTemplatesFilters {
    static readonly type = '[Asset Templates] Update Asset Templates Filters';
    constructor(public filters: TemplateFilters) { }
}

export class ResetAssetTemplatesState {
    static readonly type = '[Asset Templates] Reset Asset Templates State';
    constructor(public table: DatatableComponent) { }
}
